// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s-articles__slick .slick-dots .slick-active:after {
  transition: all 0.3s;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 8px;
  width: 0%;
  border-radius: 3px;
  background-color: #ff9840;
  animation: progress v-binds(speedInSec) linear forwards;
}
@keyframes progress {
0% {
    width: 0;
}
100% {
    width: 100%;
}
}`, "",{"version":3,"sources":["webpack://./src/js/vue/apps/Articles.vue","webpack://./Articles.vue"],"names":[],"mappings":"AAGI;EACE,oBAAA;EAEA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EAEA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EAEA,uDAAA;ACLN;ADUA;AACE;IACE,QAAA;ACPF;ADSA;IACE,WAAA;ACPF;AACF","sourcesContent":["\r\n.s-articles__slick {\r\n  .slick-dots {\r\n    .slick-active:after {\r\n      transition: all 0.3s;\r\n\r\n      content: '';\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n\r\n      height: 8px;\r\n      width: 0%;\r\n      border-radius: 3px;\r\n      background-color: #ff9840;\r\n\r\n      animation: progress v-binds(speedInSec) linear forwards;\r\n    }\r\n  }\r\n}\r\n\r\n@keyframes progress {\r\n  0% {\r\n    width: 0;\r\n  }\r\n  100% {\r\n    width: 100%;\r\n  }\r\n}\r\n",".s-articles__slick .slick-dots .slick-active:after {\n  transition: all 0.3s;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 8px;\n  width: 0%;\n  border-radius: 3px;\n  background-color: #ff9840;\n  animation: progress v-binds(speedInSec) linear forwards;\n}\n\n@keyframes progress {\n  0% {\n    width: 0;\n  }\n  100% {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
